import React, { CSSProperties, ChangeEvent } from 'react';

interface ToggleSwitchProps {
  labelStyle?: string;
  label?: string;
  checked: boolean;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  style?: CSSProperties;
  disabled?: boolean;
  /** Place the track flush left (for toggle-before-label layouts). */
  alignLeft?: boolean;
  /** For a `<label htmlFor>` outside the switch. */
  id?: string;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  labelStyle = '',
  label,
  checked,
  onChange,
  style,
  disabled = false,
  alignLeft = false,
  id,
}) => {
  return (
    <div
      className={`cl-toggle-switch${alignLeft ? ' cl-toggle-left' : ''}`}
      // eslint-disable-next-line react/forbid-dom-props -- callers position the toggle with `style`
      style={style}
    >
      <label
        className={`cl-switch ${labelStyle}${alignLeft ? ' cl-switch-left' : ''}`}
      >
        {label}
        <input
          type='checkbox'
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          id={id}
        />
        <span className='cl-slider'></span>
      </label>
    </div>
  );
};

export default ToggleSwitch;
